<template>
<div class="chapter">
<div class="inner_page">
<h1>Contents</h1>
<p class="toc"><a href="#/xhtml/06chapter01">A LAP WITHOUT A CAT IS</a> <a href="#/xhtml/06chapter01">4</a></p>
<p class="toc"><a href="#/xhtml/07chapter02">IMAGE CREDITS</a> <a href="#/xhtml/07chapter02">118</a></p>
<p class="toc"><a href="#/xhtml/08chapter03">QUOTATION CREDITS</a> <a href="#/xhtml/08chapter03">120</a></p>
<p class="toc"><a href="#/xhtml/09author">ABOUT THE AUTHOR</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05-toc.vue?1056f7db